module.exports = __webpack_public_path__ + "static/media/Yasuo.8c420ee2.png";